<style>
.GroupsTable .table__container--panel {
  background-color: #f5f7f7;
  color: #757575;
  border: 1px 1px 0px 1px solid #bdc3c7;
  border-width: 1px 1px 0px 1px;
  border-style: solid;
  border-color: rgb(189, 195, 199);
}
.GroupsTable .table__container--panel p {
  font-size: 12px;
}
.GroupsTable .table__container--separator {
  border-right: 1px solid rgba(189, 195, 199, 0.5);
  content: " ";
  height: 8px;
  margin-top: 8px;
  position: relative;
  right: 0;
  top: 0;
}
.GroupsTable .table__container--filter {
  margin: 3px;
  border: 1px solid rgba(189, 195, 199, 0.5);
  font-size: 12px;
}
</style>

<template>
  <v-layout row fill-height wrap class="GroupsTable">
    <v-layout class="table__container--panel" wrap>
      <v-icon style="padding-left: 10px" @click="show('AddGroup')" title="Dodaj grupę">person_add</v-icon>
      <v-layout align-right justify-end>
        <div style="margin-top: auto; margin-bottom: auto;">
          <p style="line-height:29px">Liczba wyników: {{numberFiltered}}/{{numberAll}}</p>
        </div>
        <input
          type="text"
          class="table__container--filter"
          v-model="filter"
          placeholder="Treść filtra"
        >
      </v-layout>
      <div class="table__container--separator"></div>
    </v-layout>
    <ag-grid-vue
      style="width: 100%; height: 90%;"
      class="ag-theme-balham"
      :gridOptions="gridOptions"
    ></ag-grid-vue>
  </v-layout>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";

export default {
  name: "App",
  data: () => ({
    tableTitle: "groupsTable",
    filter: "",
    inspectionsTaskFiltered: undefined,
    numberAll: 0,
    numberFiltered: 0
  }),
  components: {
    AgGridVue,
    Buttons: {
      template:
        '<span>\
          <v-icon small @click="removeGroup" title="Usuń grupę">delete</v-icon>\
          <v-icon small @click="managePermissions" title="Zarządzaj uprawnieniami grupy">create</v-icon>\
        </span>',
      computed: {
        activeModals() {
          return this.$store.getters.getModalsList;
        }
      },
      methods: {
        removeGroup() {
          let id = this.params.data.id;
          const self = this;
          this.$emit("confDialogOpened", true);
          self.$modal.show("dialog", {
            title: `Usuwanie grupy ${this.params.data.name}`,
            text: "Czy na pewno chcesz usunąć grupę?",
            buttons: [
              {
                title: "NIE",
                handler: () => {
                  self.$modal.hide("dialog");
                  return;
                }
              },
              {
                title: "TAK",
                default: true,
                handler: () => {
                  self.$store.dispatch("removeGroup", id).then(success => {
                    if (success) {
                      self.$root.$emit(
                        "showSnackbar",
                        "success",
                        "Pomyślnie usunięto grupę"
                      );
                      self.params.api.selectIndex(self.params.node.rowIndex);
                      let selectedData = self.params.api.getSelectedRows();
                      self.params.api.updateRowData({ remove: selectedData });
                      self.$root.$emit("groupDeleted");
                    } else {
                      self.$root.$emit(
                        "showSnackbar",
                        "red",
                        "Nie można usunąć grupy ponieważ są do niej przypisani użytkownicy"
                      );
                    }
                  });
                  self.$modal.hide("dialog");
                }
              }
            ]
          });
        },
        managePermissions() {
          this.$store.commit("setCurrentUserGroup", this.params.data.id);
          this.$store.commit("setCurrentUsername", this.params.data.name);
          if (this.activeModals.indexOf("ModifyPermissions") == -1) {
            this.$store.commit("addModal", "ModifyPermissions");
            this.$modal.show("ModifyPermissions");
          }
        }
      }
    }
  },
  computed: {
    gridOptions() {
      let gridOptions = {
        rowData: this.loadData(),
        overlayLoadingTemplate:
          '<span class="ag-overlay-loading-center">Trwa ładowanie danych</span>',
        columnDefs: this.columnDefs,
        enableSorting: "true",
        enableFilter: "true",
        onFilterModified: this.filteredNumber,
        enableColResize: "true",
        onGridReady: this.onGridReady,
        onColumnMoved: this.onColumnMoved,
        onColumnResized: this.onColumnMoved,
        onFilterChanged: this.filterColumn,
        context: {
          componentParent: this
        },
        localeText: {
          contains: "Zawiera",
          notContains: "Nie zawiera",
          equals: "Równa się",
          notEqual: "Nie równa się",
          startsWith: "Zaczyna się",
          endsWith: "Kończy się",
          noRowsToShow: "Brak danych"
        }
      };
      return gridOptions;
    },
    activeModals() {
      return this.$store.getters.getModalsList;
    }
  },
  beforeMount() {
    let dict = [
      {
        headerName: "Nazwa",
        field: "gname"
      }
    ];
    this.columnDefs = [];
    dict.forEach(field => {
      this.columnDefs.push(field);
    });
    this.columnDefs.push({
      headerName: "Opcje",
      cellRendererFramework: "Buttons"
    });
  },
  methods: {
    filterColumn() {
      this.numberFiltered = this.gridOptions.api.getModel().rootNode.childrenAfterFilter.length.toString();
    },
    show(title) {
      if (this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    filteredNumber() {
      this.numberFiltered = this.gridOptions.api.getModel().getRowCount();
    },
    loadData() {
      const self = this;
      this.$store.dispatch("getGroups").then(r => {
        if (r) {
          let tempArr = r.data.groups.filter(obj => {
            return obj.gname != null;
          });
          self.numberAll = tempArr.length;
          self.numberFiltered = tempArr.length;
          self.gridOptions.api.setRowData(tempArr);
        }
      });
    },
    onColumnMoved(params) {
      const columnState = JSON.stringify(
        this.gridOptions.columnApi.getColumnState()
      );
      localStorage[this.tableTitle] = columnState;
    },
    onGridReady(params) {
      if (localStorage[this.tableTitle]) {
        const columnState = JSON.parse(localStorage[this.tableTitle]);
        if (columnState) {
          this.gridOptions.columnApi.setColumnState(columnState);
        }
      }
    },
    fitColumns() {
      setTimeout(() => {
        if (this.gridOptions.api) this.gridOptions.api.sizeColumnsToFit();
      }, 0);
    }
  },
  watch: {
    filter(nV) {
      this.gridOptions.api.setQuickFilter(nV);
      this.numberFiltered = this.gridOptions.api.getModel().rootNode.childrenAfterFilter.length;
    }
  },
  mounted() {
    this.$root.$on("newGroupAdded", this.loadData);
    this.$root.$on("groupDeleted", this.loadData);
    this.$root.$on("initTable", this.fitColumns);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/table/users/GroupsTable.vue